export default {
  REQUESTING: 'address/countries/REQUESTING',
  RESPONSE_ERROR: 'address/countries/RESPONSE_ERROR',
  FETCH_COUNTRIES: 'address/countries/FETCH',
  LIST_COUNTRIES: 'address/countries/LIST',
}
